export { SectionBadge, EarlyDocuments as EarlyDocumentsSection } from 'Features/EarlyDocuments';
